import React, { useEffect, useRef } from 'react';
import { motion, useAnimation } from 'framer-motion';

import silverbell from '../../Assets/Partner_Logos/SilverBell_iubdki.png'
import isalis from '../../Assets/Partner_Logos/Isalis-logo.png'
import testDrive from '../../Assets/Partner_Logos/88b03c41-c2fc-48b7-84f9-3a8eab5b04e3.png'
import TravelBhutan from '../../Assets/Partner_Logos/BhutanTravel_sqvx21.webp'
import AeraVision from '../../Assets/Partner_Logos/AeraVision_xpiepu.jpg'
import weSpainClinic from '../../Assets/Partner_Logos/WeSpainClinic_mfku1l.png'
import greenVillage from '../../Assets/Partner_Logos/GreenVillage_nvbzre.png'
import RayVerse from '../../Assets/Partner_Logos/Ray-Verse-logo_bqrasj.png'
import yuv from '../../Assets/Partner_Logos/yi-logo_htyonx.webp'

const LogoCarousel = () => {
  const logos = [
    { src: silverbell, alt: "SilverBell", title: "SilverBell", description: "Real Estate" },
    { src: yuv, alt: "Yuv Industries", title: "Yuv Industries", description: "Go Green" },
    { src: isalis, alt: "Isalis", title: "Isalis", description: "Volunteer" },
    { src: testDrive, alt: "Test-Driive", title: "Test Driive", description: "Car Dealer" },
    { src: TravelBhutan, alt: "Travel-Bhutan", title: "Travel Bhutan", description: "Blog Website" },
    { src: AeraVision, alt: "AeraVision", title: "Aeravision", description: "Software Company" },
    { src: weSpainClinic, alt: "WeSpainClinic", title: "WeSpainClinic", description: "Clinic" },
    { src: greenVillage, alt: "GreenVillage", title: "GreenVillage", description: "Real Estate" },
    { src: RayVerse, alt: "RayVerse", title: "RayVerse", description: "Web Development" }
  ];

  // Duplicate the logos array to create seamless looping
  const duplicatedLogos = [...logos, ...logos, ...logos];
  const controls = useAnimation();
  const carouselRef = useRef();

  useEffect(() => {
    const carouselWidth = carouselRef.current?.scrollWidth;
    const itemWidth = carouselRef.current?.firstChild?.offsetWidth;
    const duration = (carouselWidth / itemWidth) * 2; // Adjust speed based on content

    const sequence = async () => {
      await controls.start({
        x: [-carouselWidth / 3, -carouselWidth / 3 * 2],
        transition: { duration, ease: "linear", repeat: Infinity }
      });
    };

    sequence();
  }, [controls]);

  return (
    <div className=" py-1 overflow-hidden ">
      
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-6">
          <span className="relative inline-block bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400">
              Trusted by Industry Leaders
          </span>
        </h2>
        
        <div className="relative ">
          
          
          {/* Main Carousel */}
          <motion.div
            ref={carouselRef}
            className="flex "
            animate={controls}
          >
            {duplicatedLogos.map((logo, index) => (
              <motion.div
                key={`${logo.alt}-${index}`}
                className="flex-shrink-0 px-2 lg:px-12 "
                whileHover={{ scale: 1.05 }}
              >
                <div className="rounded-xl p-2 h-full flex flex-col items-center justify-center shadow-sm hover:shadow-md transition-all duration-300">
                  <img 
                    src={logo.src} 
                    alt={logo.alt} 
                    className="sm:h-14 h-10 w-auto object-contain mb-4"
                    loading="lazy"
                  />
                  <h4 className="text-lg font-semibold text-white">{logo.title}</h4>
                  <p className="text-gray-500 text-sm mt-1">{logo.description}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      
    </div>
  );
};

export default LogoCarousel;